import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../../lib/utils";

import { HTMLAttributes } from "react";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        successGreen: "border-transparent bg-statusGreen text-white hover:bg-green-500/80",
        warningYellow: "border-transparent bg-statusYellow text-white hover:bg-yellow-500/80",
        errorRed: "border-transparent bg-statusRed text-white hover:bg-red-500/80"
      },
      size: {
        default: "",
        rounded: "w-5 h-5.5 rounded-full"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);

export interface BadgeProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
